import { render, staticRenderFns } from "./Absence.vue?vue&type=template&id=67f5f79f&scoped=true"
import script from "./Absence.vue?vue&type=script&lang=js"
export * from "./Absence.vue?vue&type=script&lang=js"
import style0 from "./Absence.vue?vue&type=style&index=0&id=67f5f79f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5f79f",
  null
  
)

export default component.exports